import {_request, _requestForm} from "./api";

export const add = (date) => {
    console.log('date',date)
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: 'player', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (date,document_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: `player/${document_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (document_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `player/${document_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player/item', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (date) => {
    let params = date;
    console.log('params',params)
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const documentHistory = (player_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `player/document-history/${player_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listForeigner = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player/foreigner', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listGender = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player/gender', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listPosition = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player/position', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const validateJMBG = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player/validate-jmbg', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listSelection = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'player/selection', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


